<template>
<div>
	<PreScreen v-if="waiting_room" :accessConfirmed="access_granted" @join="join" :room="room"></PreScreen>
	<AccessDenied v-if="participant.status == 'access_denied' || !logged_in "></AccessDenied>
	<Disconnected v-if="participant.status == 'disconnected'"></Disconnected>
	<VideoWrapper v-if="joined" :settings="participant" :room="room"></VideoWrapper>
</div>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import firebase from "firebase";
	import Vuex from "vuex";
	import video from "@/store/modules/Video.js"
	import PreScreen from "./PreScreen.vue"
	import AccessDenied from "./AccessDenied.vue"
	import Disconnected from "./Disconnected.vue"
	import VideoWrapper from "./VideoWrapper.vue"
	export default {
		name: "Video", 
		props: {
			room: {}	
		},
		data: () => {
			return {
				error: false,
				processing: false
			}
		},
		components: {
			PreScreen, 
			VideoWrapper, 
			AccessDenied, 
			Disconnected
		},
		computed: {
			...Vuex.mapState({
				logged_in: state => state.auth.logged_in,
				user: state => state.auth.user, 
				view: state => state.auth.view,	
				video: state => state.video		
			}),
			video_room(){
				var video_room = this.$store.state.video;
				if( !video_room ){
					return false;
				}
				if( video_room.id == this.room ){
					return video_room
				}
				return false
			},
			participant(){
				var participant = this.video_room.participant
				return participant || false;
			}, 
			waiting_room(){
				if( !this.logged_in ){
					return false;
				}
				return !this.participant || this.participant.status == "waiting_room" || this.participant.status == "access_granted"
			}, 
			access_granted(){
				return this.participant ? this.participant.status == "access_granted" : false;
			},
			joined(){
				return this.participant ? this.participant.status == "joined" : false;
			}
		},
		methods: {
			async checkRoom(room){
				var user = this.user.uid;
				var functions = firebase.app().functions('europe-west1');
				var checkRoom = functions.httpsCallable('checkRoom');
				return await checkRoom({room: room, user: user});

			},
			join(settings){
				this.call_started = new Date(); 
				var data = {...settings}; 
				data.status = "joined"
				if( this.access_granted ){
					this.$store.dispatch("updateDoc", {
						doc: `videoRooms/${this.room}/participants/${this.user.uid}`, 
						action: "update", 
						data: data 
					})
				}
				else{
					this.error = "You don't have permission to access this call"
				}
			}, 
		},
		watch: {
			access_granted: {
				immediate: true, 
				handler( nv, ov ){
					if( nv && false == ov ){
						this.$store.dispatch("video/fetchRoom", this.room )
					}
				}
			},
			access_denied: {
				immediate: true, 
				handler( nv, ov ){
					if( nv && !ov ){
						this.error = "Permission to access call denied. Please contact Meisterworks if you think this is a mistake"
					}
				}
			},
			user: {
				immediate: true, 
				handler( user ){
					if( user && !this.processing ){
						const self = this;
						self.processing = true;
						self.checkRoom(self.room).then( () => {
							self.$store.dispatch("video/fetchRoomParticipant", self.room  )
						}).catch( () => {
							// console.log(err)
						})
					}

				}
			}
		}, 
		mounted(){
			this.$store
		}, 
		created(){
			if( !this.$store.state.video ){
				this.$store.registerModule("video", video )
			}
		}
	}
// </script>"